// The signed-in user and their token (SPEC §7.1). Kept in this browser until sign-out or expiry.

import type { AuthUser, SchoolInfo } from "./api/types";

const TOKEN_KEY: string = "webuniverse.token";

let token: string | null = readToken();
let currentUser: AuthUser | null = null;
let school: SchoolInfo | null = null;

export function getToken(): string | null {
  return token;
}

export function getUser(): AuthUser | null {
  return currentUser;
}

/** The signed-in user; calling it before sign-in is a bug. */
export function requireUser(): AuthUser {
  if (currentUser === null) {
    throw new Error("No signed-in user");
  }

  return currentUser;
}

export function startSession(newToken: string, user: AuthUser): void {
  token = newToken;
  currentUser = user;
  writeToken(newToken);
}

export function setUser(user: AuthUser): void {
  currentUser = user;
}

export function endSession(): void {
  token = null;
  currentUser = null;
  writeToken(null);
}

export function getSchool(): SchoolInfo | null {
  return school;
}

/** School info from GET /school; its "today" is the default for every date (SPEC §8.4). */
export function requireSchool(): SchoolInfo {
  if (school === null) {
    throw new Error("School info not loaded");
  }

  return school;
}

export function setSchool(info: SchoolInfo): void {
  school = info;
}

export function isAdmin(): boolean {
  return currentUser?.role === "Admin";
}

function readToken(): string | null {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

function writeToken(value: string | null): void {
  try {
    if (value === null) {
      window.localStorage.removeItem(TOKEN_KEY);
      return;
    }

    window.localStorage.setItem(TOKEN_KEY, value);
  } catch {
    // Storage blocked: the session lasts for this page only.
  }
}
